import React from 'react'

export default ({ ...props }) => (
  <svg
    {...props}
    className='icon icon__play-btn'
    width='70'
    height='70'
    viewBox='0 0 70 70'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g opacity='0.9'>
      <path
        className='icon__play-btn--bg'
        d='M64.75 70H5.25C2.3555 70 0 67.6445 0 64.75V5.25C0 2.3555 2.3555 0 5.25 0H64.75C67.6445 0 70 2.3555 70 5.25V64.75C70 67.6445 67.6445 70 64.75 70Z'
      />
      <path
        className='icon__play-btn--play-icon'
        d='M24.5 55.9999C24.22 55.9999 23.94 55.9334 23.6845 55.8004C23.1105 55.4994 22.75 54.9009 22.75 54.2534V15.7534C22.75 15.1024 23.1105 14.5074 23.6845 14.2064C24.2585 13.9054 24.955 13.9439 25.4905 14.3149L53.4905 33.5649C53.9665 33.8904 54.25 34.4294 54.25 35.0069C54.25 35.5844 53.9665 36.1234 53.4905 36.4489L25.4905 55.6989C25.193 55.9019 24.8465 56.0069 24.5 56.0069V55.9999Z'
        fill='white'
      />
    </g>
  </svg>
)
